import React, {Fragment, lazy, Suspense} from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero4 from '../../components/hero4/hero4';
import About4 from '../../components/about4/about4';
import Scrollbar from '../../components/scrollbar/scrollbar';

const FunFactSection = lazy(() => import('../../components/FunFact/FunFact'));
const ServiceSection = lazy(() => import('../../components/ServiceSection/ServiceSection'));
const WorkRedirect = lazy(() => import('../../components/WorkRedirect/WorkRedirect'));
const ContactArea = lazy(() => import('../../components/ContactArea'));
const Footer = lazy(() => import('../../components/footer/Footer'));

const HomePage4 =() => {
    return(
        <Fragment>
            <div className="dark-mode">
                <Navbar hclass={'wpo-header-style-3'} topbarNone={'topbar-none'}/>
                <Hero4/>
                <About4/>
                <Suspense fallback={<div />}>
                    <FunFactSection fClass={'wpo-fun-fact-section-s4'}/>
                    <ServiceSection/>
                    <WorkRedirect/>
                    <ContactArea btnClass={'theme-btn-s3'}/>
                    <Footer ftClass={'wpo-site-footer-s2'}/>
                </Suspense>
                <Scrollbar/>
            </div>
        </Fragment>
    )
};
export default HomePage4;